<template>
  <div
    v-if="items"
    class="list">
    <p
      v-if="title"
      class="list__title"
      v-html="title"/>
    <ul
      class="list__items"
      :class="{'list__items--errors': displayErrors}"
    >
      <li
        v-for="message in items"
        v-html="trans(message)"
      />
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'GcList',
    props: {
      title: {
        required: false,
        default: null
      },
      displayErrors: {
        default: false,
      },
      items: {
        required: true,
        default: null
      }
    }
  }
</script>

<style>
  .balance-checker .list {
    font-size: .8em;
    line-height: 1.4;
  }

  .balance-checker .list__title {
    margin: 0 0 .5rem 0;
    font-weight: bold;
  }

  .balance-checker .list__items {
    margin: 0;
    padding: 0;
    line-height: 1.4;
    list-style: none;
  }

  .balance-checker .list__items--errors {
    font-size: .75rem;
    color: #B00020;
    font-style: italic;
  }
</style>
